export const BIZ_DEVELOPMENT_DASHBOARD_QUERY_ID = "5657818854064128";
export const BIZ_DEVELOPMENT_BUDGET_QUERY_ID = "5693366486433792";
export const BIZ_DEVELOPMENT_BUDGET_LAST_RUN_QUERY_ID = "5656281524207616";
export const SIXWEEKQID = "5649205632696320";
export const LASTTHIRTYDAYSQID = "5685839489138688";
export const LASTTWELVEMONTHQID = "5650452045627392";
export const BIZ_OVERVIEW_CONVERSIONS_QUERY_IDS = {
  action: "5722078678351872",
  click: "5663297554612224",
  campaignFilter: "5728744266268672",
  adgroupFilter: "5658330156498944",
  keywordFilter: "5718746756808704",
} as const;
export const BIZ_BE_AWARE_QUERY_IDS = {
  fraudPlayers: "5766621448634368",
  negativeBalance: "5659211052613632",
  conversionsUpload: "5671603350274048",
} as const;

export const BIZ_ANOMALIES_QUERY_IDS = {
  missingData: "5697673499770880",
  zeroPerformanceFtd: "6518167308337152",
  problematicFtd: "5703358593630208",
  withoutFtdAndNetRevBrand: "4688579959717888",
  gapsBetweenPlayersAndDailyPerformance: "5646137709035520",
  incomeGapsInMTD: "6236692331626496",
  decreaseDailyIncomeGapsMTD: "6377429819981824",
  dailyEarningGapsMTD: "5251529913139200",
  monthlyEarningGapsMTD: "5814479866560512",
} as const;
